const state = {
    wxMiniAppConfigMap: {},
};

const getters = {
    getWxMiniAppConfigMap: state => url => {
        let value = state.wxMiniAppConfigMap[url];
        if (value == null || value == undefined)
        {
            value = {
                expireTime: 0,
                ifWeChatJsApiAuthFinish: false,
                ifWeChatJsApiAuthSuccess: false,
            }
        }

        if (Date.now() > value.expireTime) {
            return {
                ifNeedAuth: true,
                ifWeChatJsApiAuthFinish: false,
                ifWeChatJsApiAuthSuccess: false,
            };
        }
        
        return {
            ifNeedAuth: false,
            ifWeChatJsApiAuthFinish: value.ifWeChatJsApiAuthFinish,
            ifWeChatJsApiAuthSuccess: value.ifWeChatJsApiAuthSuccess,
        };
    },
};

const mutations = {
    setWxMiniAppConfigMap(state, {
        url,
        pageInstance,
    }) {
        pageInstance.$set(state.wxMiniAppConfigMap, url, {
            expireTime: Date.now() + 10 * 60 * 1000,
            ifWeChatJsApiAuthFinish: false,
            ifWeChatJsApiAuthSuccess: false,
        });
    },

    setWxMiniAppConfigMapState(state, {
        pageInstance,
        url,
        ifWeChatJsApiAuthFinish,
        ifWeChatJsApiAuthSuccess,
    })
    {
        let value = state.wxMiniAppConfigMap[url];
        if (value == null || value == undefined) {
            value = {
                expireTime: 0,
                ifWeChatJsApiAuthFinish: false,
                ifWeChatJsApiAuthSuccess: false,
            }
        }

        value.ifWeChatJsApiAuthFinish = ifWeChatJsApiAuthFinish;
        value.ifWeChatJsApiAuthSuccess = ifWeChatJsApiAuthSuccess;

        pageInstance.$set(state.wxMiniAppConfigMap, "url", value);
    }
};

export default {
    state,
    getters,
    mutations,
};